export default __webpack_public_path__ + "static/media/Group-2.9e91239a.png";